//src/services/adminTopBanner.api.js
import { adminApiRequest } from "./adminApi";

/**
 * Get all top banner messages (admin)
 */
export const getAdminTopBanners = () =>
  adminApiRequest("/top-banner/admin");

/**
 * Create new banner message
 */
export const createAdminTopBanner = (data) =>
  adminApiRequest("/top-banner/admin", {
    method: "POST",
    body: JSON.stringify(data),
  });

/**
 * Update existing banner message
 */
export const updateAdminTopBanner = (id, data) =>
  adminApiRequest(`/top-banner/admin/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

/**
 * Delete banner message
 */
export const deleteAdminTopBanner = (id) =>
  adminApiRequest(`/top-banner/admin/${id}`, {
    method: "DELETE",
  });
